import {
  Mapping,
  MappingIdentifier,
} from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { doMappingUpdated } from 'src/containers/ProjectDiagram/utils/mapping/doMappingUpdated';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

/** sets `primaryIdentifier` on Mapping */
export const setMappingPrimaryIdentifier =
  ({
    key,
    primaryIdentifier,
  }: {
    key: string;
    primaryIdentifier: MappingIdentifier;
  }) =>
  (model: Model) => {
    const mapping = model.linkDataArray.find(
      (linkData): linkData is Mapping =>
        isMapping(linkData) && linkData.key === key
    );
    if (!mapping) {
      return;
    }

    setDataProperty<Mapping>(model)(
      mapping,
      'primaryIdentifier',
      primaryIdentifier
    );

    doMappingUpdated(mapping)(model);
  };
